import type { ReactElement } from 'react';

import * as icons from '../icons';
import { ICONS } from '../icons/icon.constants';

export const getIconComponent = (
    iconName: string,
    options: {
        size?: 'auto' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';
        className?: string;
    }
): ReactElement | null => {
    if (icons && ICONS.includes(iconName as keyof typeof icons)) {
        const IconComponent = icons[iconName as keyof typeof icons];
        return <IconComponent {...options} aria-hidden="true" />;
    }
    return null;
};
